import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";

export async function updateAdmin(adminId, payload) {
    return updateDoc(doc(db, "admins", adminId), payload);
}
